import { QueryFunctionContext } from '@tanstack/react-query'
import backendRequest from '../../../services/api/backendRequest'
import depreciationEndpoints from '../api/depreciationEndpoints'
import { investmentQueryKeys } from '../../investment/queries/investmentQueryKeys'
import { GET, PUT } from '../../../redux/middleware/types'
import { DeprecationSeriesReportRow, DepreciationCorrectionPayload } from '../types'

export const getInvestmentDepreciations = async ({
  queryKey: [{ companyId, investmentId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof investmentQueryKeys)['depreciations']>>) => {
  return backendRequest<DeprecationSeriesReportRow[]>({
    method: GET,
    url: depreciationEndpoints.depreciations(companyId, investmentId),
    signal
  })
}

export const batchSaveDepreciationCorrections = async (
  companyId: string,
  investmentId: number,
  corrections: DepreciationCorrectionPayload[],
  budgetingScenarioId?: number
) => {
  return backendRequest<DeprecationSeriesReportRow[]>({
    method: PUT,
    url: depreciationEndpoints.corrections(companyId, investmentId),
    data: corrections,
    params: { budgetingScenarioId }
  })
}
